import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../mock";
import { fetchServices } from "../../api";

export default function ServicesSection() {
  const [services, setServices] = useState(SERVICES);
  useEffect(() => {
    fetchServices().then((d) => { if (d && d.length) setServices(d); }).catch((e) => console.error("Services load failed:", e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const featured = services.slice(0, 6);
  return (
    <section className="bg-charcoal py-28 relative grain">
      <div className="max-w-[1300px] mx-auto px-6 relative z-10">
        <div className="text-center max-w-2xl mx-auto reveal">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="gold-rule" />
            <span className="eyebrow text-gold">Signature Treatments</span>
          </div>
          <h2 className="font-display text-4xl lg:text-5xl font-light text-cream leading-tight">
            Curated treatments for <span className="italic text-gold">timeless</span> beauty
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
          {featured.map((s, i) => (
            <Link
              to="/services"
              key={s.id}
              className="lux-card group relative rounded-sm overflow-hidden bg-charcoal-soft reveal"
              style={{ transitionDelay: `${(i % 3) * 90}ms` }}
            >
              <div className="img-zoom h-64">
                <img src={s.image} alt={s.name} className="w-full h-full object-cover opacity-85 group-hover:opacity-100 transition-opacity" />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/20 to-transparent" />
              </div>
              <div className="p-7">
                <span className="eyebrow text-gold">{s.category}</span>
                <div className="flex items-start justify-between gap-4 mt-3">
                  <h3 className="font-display text-2xl text-cream font-normal leading-snug">{s.name}</h3>
                  <ArrowUpRight size={22} className="text-gold shrink-0 group-hover:rotate-45 transition-transform duration-500" />
                </div>
                <p className="font-sans text-cream/55 text-sm leading-relaxed mt-3">{s.short}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-14 reveal">
          <Link to="/services" className="btn-outline-gold">View All Treatments</Link>
        </div>
      </div>
    </section>
  );
}
